module.exports = __webpack_public_path__ + "static/img/mando-pr.b3d070c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/mando-pr.jpg
// module id = RxXa
// module chunks = 0